import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ProposalResponse.scss';

class ProposalResponse extends Component {
  renderNotes() {
    const { notes, extraSpanClasses } = this.props;
    if (notes) {
      return (
        <div
          ref={(el) => { this.notesElement = el; }}
          className={`g-column body-text-3 ${extraSpanClasses}`}
        >
          {notes}
        </div>
      );
    }

    return (
      <div
        ref={(el) => { this.notesElement = el; }}
        className="hide"
      />
    );
  }

  render() {
    const {
      checked, description, extraClasses, notes,
    } = this.props;
    return (
      <div className={`proposal-response ${checked} ${extraClasses}`}>
        { description ? [
          <strong>{description}</strong>,
          this.renderNotes(),
        ] : notes}
      </div>
    );
  }
}

ProposalResponse.propTypes = {
  checked: PropTypes.string,
  description: PropTypes.string,
  notes: PropTypes.string,
  extraClasses: PropTypes.string,
  extraSpanClasses: PropTypes.string,
};

ProposalResponse.defaultProps = {
  checked: '',
  description: '',
  notes: '',
  extraClasses: '',
  extraSpanClasses: '',
};

export default ProposalResponse;
